import { DOCUMENT_TYPE } from "./documentType";
export default {
    [DOCUMENT_TYPE.GRAPH]: "icon-graph",
    [DOCUMENT_TYPE.TABLE]: "icon-table",
    [DOCUMENT_TYPE.MAP]: "icon-map",
    [DOCUMENT_TYPE.CONTENT]: "icon-gallery"
};
